import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useTotalVaccinationByAge from './hooks/useTotalVaccinationByAge';

export const TotalVaccinationByAge = () => {
    const { chartConfig } = useTotalVaccinationByAge();

    return (
        <ChartContainer
            title={"Aplicação de Vacinas por Faixa Etária"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
